import { ref, reactive, computed } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useContactForm() {
    const formData = reactive({
        email: '',
        subject: '',
        message: ''
    });

    const isSending = ref(false);
    const isSuccess = ref(false);
    const captchaToken = ref(null);
    const sitekey = process.env.VUE_APP_CLOUDFLARE_SITE_KEY;


    const footer = computed(() => store.getters.getFooter);

    const canSubmit = computed(() => !!captchaToken.value && !isSending.value);

    const onCaptchaVerified = token => {
        captchaToken.value = token;
    };

    const submitMessage = async() => {
        if (!canSubmit.value) return;

        isSending.value = true;

        const payload = {
            ...formData,
            captchaToken: captchaToken.value
        };

        try {
            await store.dispatch(config.getVuexAlias('front.ayuda'), payload);
            isSuccess.value = true;
            return true;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            isSending.value = false;
        }
    };

    return {
        formData,
        isSending,
        isSuccess,
        footer,
        sitekey,
        onCaptchaVerified,
        submitMessage,
        canSubmit
    };
}
